import React from 'react';

export interface AvatarIconProps {
  size?: number | string;
  color?: string;
}

export function AvatarIcon({ size = 18, color = 'currentColor' }: AvatarIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99964 1.02942C4.10628 1.02942 3.38207 1.75366 3.38207 2.64706C3.38207 3.54047 4.10628 4.26471 4.99964 4.26471C5.893 4.26471 6.61721 3.54047 6.61721 2.64706C6.61721 1.75366 5.893 1.02942 4.99964 1.02942ZM2.49976 2.64706C2.49976 1.26635 3.61899 0.147064 4.99964 0.147064C6.38028 0.147064 7.49952 1.26635 7.49952 2.64706C7.49952 4.02778 6.38028 5.14706 4.99964 5.14706C3.61899 5.14706 2.49976 4.02778 2.49976 2.64706Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.4337 5.10094C6.75376 4.9428 7.11203 4.85295 7.47585 4.85295H7.49719C8.80033 4.85295 9.8524 5.92414 9.8524 7.24534V7.7083C9.8524 8.56407 9.28033 9.33504 8.42817 9.53733C5.94286 10.1273 4.1349 10.154 1.56393 9.53923C0.714301 9.33608 0.146973 8.5661 0.146973 7.71423V7.24534C0.146973 5.93137 1.19192 4.86018 2.50217 4.86018C2.86044 4.86018 3.21206 4.94029 3.53721 5.10094L4.35444 5.50513C4.76535 5.70505 5.23894 5.70448 5.6478 5.50001C5.64814 5.49984 5.64847 5.49968 5.6488 5.49951L6.42937 5.10311L6.4337 5.10094ZM6.82656 5.89101L6.04404 6.28839C5.38617 6.61802 4.62257 6.61746 3.96675 6.29774L3.9645 6.29664L3.14638 5.89201C3.14633 5.89198 3.14643 5.89203 3.14638 5.89201C2.94502 5.79255 2.72731 5.74253 2.50217 5.74253C1.69203 5.74253 1.02928 6.40575 1.02928 7.24534V7.71423C1.02928 8.17979 1.3375 8.57786 1.76911 8.68107C4.20088 9.26253 5.86867 9.23805 8.22439 8.67884C8.65942 8.57557 8.97008 8.17554 8.97008 7.7083V7.24534C8.97008 6.39853 8.30022 5.7353 7.49719 5.7353H7.47585C7.25692 5.7353 7.03248 5.78963 6.82656 5.89101Z"
        fill={color}
      />
    </svg>
  );
}
